/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_SavedInputs */



/**
* | output |
* | --- |
* | "Guide details saved" |
*
* @param {Knp_Guide_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_saved = /** @type {((inputs?: Knp_Guide_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détails du guide enregistrés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leitfadendetails gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dettagli della guida salvati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранены подробные сведения о руководстве.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detalles de la guía guardados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("指南详情已保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガイドの詳細を保存しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गाइड का विवरण सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detalhes do guia salvos")
	return /** @type {LocalizedString} */ ("Guide details saved")
});